module.exports = __webpack_public_path__ + "img/File.acbf2ff2.svg";